// Navigate to a download URL returned by our own service. The value must be an
// absolute https URL; reject http, relative paths, and javascript:/data: schemes
// before assigning window.location so a hostile value can't run in the page.
export const safeDownload = (url: string): void => {
  try {
    if (new URL(url).protocol === 'https:') {
      window.location.href = url;
    }
  } catch {
    // Malformed URL — do nothing.
  }
};
